import create from './create';
import deleteApi from './delete';
import detail from './detail';
import edit from './edit';
import list from './list';
import resetPassword from './reset-password';
import resetTwoFactor from './reset-two-factor';

const ApiCall = {
  list,
  detail,
  create,
  edit,
  delete: deleteApi,
  resetPassword,
  resetTwoFactor,
};

export default ApiCall;
